import React from "react";

function PreHero() {
  return (
    <section className="banner-area">
      <div
        className="banner-shape"
        style={{
          background: `url(${require(`../../assets/img/banner/banner_shape1.jpg`)})`,
        }}
      ></div>
      <div className="banner-bg">
        <div className="row align-items-center">
          <a href="/contact">
          <img
            src={require(`../../assets/img/banner/prehero.jpeg`)}
            alt=""
            className="wow fadeInRight"
            data-wow-delay=".4s"
          /></a>
        </div>
      </div>
    </section>
  );
}

export default PreHero;